import CssClass from "../../Styles/common.module.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateTimePicker = (props) => {
  const errorMessage = props.errorMessage === undefined ? "" : props.errorMessage;
  return (
    <div
      className={`form-group ${
        props.label !== undefined && CssClass.modalGroup
      }`}
    >
      {props.label !== undefined && (
        <label className={CssClass.colFormLabel} htmlFor={props.id}>
          {props.label}
        </label>
      )}
      <div className={CssClass.modalPopupItem}>
        <DatePicker
          {...props}
          className={`${
            props.className !== undefined ? props.className : "form-control"
          } ${
            props.label !== undefined &&
            props.isValid === false &&
            CssClass.invalidField
          }`}
          dateFormat={props.dateFormat !== undefined ? props.dateFormat : "dd/MM/yyyy"}
          isClearable={props.disabled !== undefined ? !props.disabled : true}
          disabled={ props.disabled !== undefined ? props.disabled : false}
          // popperClassName="custom-calendar-popper" 
          // modalPopupItem = {{zIndex : 99 , Position: "relative"}}
          popperProps={{
            modifiers: [
              {
                name: "zIndex",
                enabled: true,
                phase: "write",
                fn: ({ state }) => {
                  state.styles.popper.zIndex = 99; // Inline zIndex style
                  // state.styles.popper.width = "1000px";
                },
              },
              // {
              //   name: "autoWidth",
              //   enabled: true,
              //   phase: "beforeWrite",
              //   fn: ({ state }) => {
              //     // Set the popper width to match the input width
              //     state.styles.popper.width = 'auto';
              //   },
              // },
              // {
              //   name: "preventOverflow",
              //   enabled: true,
              //   phase: "write",
              //   fn: ({ state }) => {
              //     const popper = state.elements.popper;
              //     const viewportWidth = window.innerWidth;

              //     // Prevent the popper from overflowing the viewport width
              //     if (state.styles.popper.left + parseFloat(state.styles.popper.width) > viewportWidth) {
              //       state.styles.popper.left = `${viewportWidth - parseFloat(state.styles.popper.width)}px`;
              //     }
              //   },
              // },
            ],
          }}
        />
        {errorMessage !== "" && (
          <div className={CssClass.invalidMessage}>{errorMessage}</div>
        )}
      </div>
    </div>
  );
};

export default DateTimePicker;
